export default __webpack_public_path__ + "static/media/screen1.f6ed9341.png";